import { useEffect, useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';

import MainPage from './pages/MainPage/MainPage';
import AdminPage from './pages/AdminPage/AdminPage';
import Layout from './components/Layout/Layout';
import LoadingPage from './pages/LoadingPage/LoadingPage';
import { login } from './msalConfig';

function App() {
    const [user, setUser] = useState({});
    const navigate = useNavigate();

    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0] || {});
    
    useEffect(() => {
        login(instance, account);
    }, [instance, account]);
    
    useEffect(() => {
        if (account && Object.keys(account).length) {
            setUser({ username: account?.username });
            navigate('/');
        } else {
            navigate('/loading');
        }
    }, [account]);

    return (
        <Routes>
            <Route
                path='/'
                element={
                <Layout user={user} >
                        <MainPage user={user}/>
                    </Layout>
                }
            />
            <Route
                path='admin'
                element={
                    <Layout user={user}>
                        <AdminPage />
                    </Layout>
                }
            />
            <Route path='loading' element={<LoadingPage />} />
        </Routes>
    );
}

export default App;
